export default __webpack_public_path__ + "static/media/sort-arrow-down.5fcddccb.svg";